module.exports = __webpack_public_path__ + "static/media/down-naranja.dee43871.svg";